import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "toggleVisibility"]

  toggle() {
    let contentTarget = this.contentTarget

    this.toggleVisibilityTargets.forEach((element) =>{
      element.classList.toggle("hidden")
    })

    // Firefox offers saved logins on any type=password field and ignores
    // autocomplete="one-time-code". Those fields stay type=text and mask
    // with CSS instead of flipping to a password input.
    let visible = false
    if (contentTarget.hasAttribute("data-access-token-css-mask")) {
      visible = contentTarget.classList.toggle("access-token-revealed")
    } else if (contentTarget.getAttribute("type") == "password") {
      contentTarget.type = "text"
      visible = true
    } else {
      contentTarget.type = "password"
    }

    this.dispatch("toggled", { detail: { visible } })
  }
}
